import React, { useEffect, useState } from "react";
import { useFormContext, Controller, useWatch } from "react-hook-form";
import { Col, Container, FormFeedback, Input, Label, Row } from "reactstrap";
import {
  InputEmail,
  InputNumber,
  InputPassword,
  InputText,
} from "../../../components/inputs";
import Select from "react-select";
import {
  enumTypesPersons as entities,
  fakeDataSignature,
  typesPersons,
} from "./options";
import Divider from "../../../components/divider";
import InputSelect from "../../../components/inputs/select";
import { departmentsOptions } from "../../invoice-issuance/db/departments";
import { municipalityOptions } from "../../invoice-issuance/db/municipalities";
import { districtsOptions } from "../../invoice-issuance/db/districts";
import { economicActivity } from "../../invoice-issuance/db/economicActivity";
import { invoicesdb } from "../db/invoices";
import { contributorTypedb } from "../db/contributorType";
import Cleave from 'cleave.js/react'
import classnames from 'classnames'
import { useDispatch, useSelector } from "react-redux";
import { getCities, getDistricts } from "../../invoice-issuance/thunks";
import InputInternationalPhone from "../../../components/inputs/internationalPhone";
import InputMask from 'react-input-mask';


const FormBase = ({ input = {}, initialTypeEntity = {value: null, label: null}}) => {
  const { LEGAL, NATURAL } = entities;
  const {
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();

  const [entitySelected, setEntity] = React.useState(initialTypeEntity?.value);
  const [filteredMunicipalities, setFilteredMunicipalities] = React.useState([]);
  const [data, setData] = useState(null)

  const { countries, departments, cities, districts, economicActivities, documentTypes, taxpayerTypes } = useSelector(state => state.invoiceIssuance)

  // CAT-091 desde el backend: sus id cambian entre ambientes. La lista
  // estática solo sirve de respaldo para no dejar el select vacío
  const hayTaxpayerTypes = Array.isArray(taxpayerTypes) && taxpayerTypes.length > 0
  const contributorOptions = hayTaxpayerTypes ? taxpayerTypes : contributorTypedb

  const dispatch = useDispatch()

  const economicActivityWithCombinedLabel = (economicActivities || {}).map ? economicActivities.map(option => ({
    ...option,
    label: `${option.value} - ${option.label}`,
  })) : [];

  const handleOnchangeSelectEntity = (e) => {
    console.log("e.value: ", e.value);
    setEntity(e.value);
    if (!input?.NIT?.disabled) {
      setValue("nit", "");
      setValue("dui", "");
      setValue("nrc", "");
    } 
    
  };

  const [servicesSelected, setServicesSelected] = React.useState({
    service_to_acquire_digital_signature: [],
    service_to_acquire_digital_invoice: [],
  });
  
  const department = useWatch({
    control,
    name: 'department',
  });

  const municipality = useWatch({
    control,
    name: 'municipality',
  });

  const country = useWatch({
    control,
    name: 'country',
  });

  const matchesSelectedAddress = (district) =>
    district.department === department?.value &&
    district.municipality === municipality?.value
  const districtOptions = Array.isArray(districts) && districts.length ? districts : districtsOptions.filter(matchesSelectedAddress)

  const filtereddocumentTypes = documentTypes?.filter ? documentTypes?.filter(item =>
    invoicesdb.some(val => val.value === item.value)
  ) : [];
  
  const handleOnchangeSignatureDigital = (e) => {
    setServicesSelected({
      ...servicesSelected,
      service_to_acquire_digital_signature: e,
    });
  };

  const handleOnchangeDigitalInvoice = (e) => {
    setServicesSelected({
      ...servicesSelected,
      service_to_acquire_digital_invoice: e,
    });
  };

  useEffect(() => {
    const selectedDepartment = department;
    console.log("department: ", department )
    if (selectedDepartment) {
      const filtered = municipalityOptions.filter(muni => muni.department === selectedDepartment.value);
      setFilteredMunicipalities(filtered);
    } else {
      setFilteredMunicipalities([]);
    }
  }, [department]);

  useEffect(() => {
    if (department?.value) {
        dispatch(getCities(department?.value))
    }
}, [dispatch, department])

  useEffect(() => {
    if (department?.value && municipality?.value) {
      dispatch(
        getDistricts({
          departmentCode: department?.value,
          municipalityCode: municipality?.value,
        })
      )
    }
  }, [dispatch, department, municipality])

  useEffect(() => {
    if (country && country?.value !== "SV") {
      setValue('department', { id: "29", label: "Otro (Para extranjeros)", value: "00" })
      setValue('municipality', { id: "572", label: "Otro (Para extranjeros)", value: "00" })
      setValue('district', { label: "Otro (Para extranjeros)", value: "00" })
    }
  }, [country, setValue])

  return (
    <React.Fragment>
      {/* <Row className="mx-0" style={{ paddingTop: '2%', paddingLeft: '5%' }}> */}
      <Divider title="Información principal" />
      <Row className="mb-1">
        <Col md="6" sm="12">
          <InputText
            label={"Nombre del cliente*"}
            errors={errors}
            options={{
              control,
              id: "receiverName",
              name: "receiverName",
              // disabled: true
            }}
          />
        </Col>
        <Col md="6" sm="12">
          <Label>Tipo de persona</Label>
          <Controller
            name="typeEntity"
            control={control}
            render={({ field }) => (
              <>
                <Select
                  {...field}
                  name="typeEntity"
                  id="typeEntity"
                  //value={typesPersons.find((item) => item.value === entitySelected) || null}
                  options={typesPersons}
                  //onChange={(e) => {
                  //field.onChange({value: e.value, label: e.label})
                  //handleOnchangeSelectEntity(e)

                  //}
                  //  }
                  isDisabled={input?.typeEntity?.disabled}
                />
                {errors.typeEntity && (
                  <FormFeedback className="d-block">
                    {errors.typeEntity.message}
                  </FormFeedback>
                )}
              </>
            )}
          />
        </Col>
      </Row>
      <Row className="mb-1">
        <Col md="4" sm="12">
          <Label className="me-1">Tipo de documento a emitir</Label>
          <Controller
            name="dteType"
            control={control}
            render={({ field }) => (
              <>
                <Select
                  {...field}
                  options={filtereddocumentTypes}
                  //value={invoicesdb.find((item) => item.value === entitySelected) || null}
                  isDisabled={input?.dteType?.disabled}
                  onChange={(e) => {
                    //setFilterProps({ ...filterProps, dteType: e.value})
                    field.onChange({
                      value: e.value,
                      label: e.label,
                      id: e.id,
                    });
                    handleOnchangeSelectEntity(e);
                  }}
                />
                {errors.dteType && (
                  <FormFeedback className="d-block">
                    {errors.dteType.message}
                  </FormFeedback>
                )}
              </>
            )}
          />
        </Col>
        {entitySelected === "01" && entitySelected !== null && (
          // <Col md="4" sm="6">
          //       <InputNumber
          //         label={"DUI*"}
          //         errors={errors}
          //         control={control}
          //         disabled={input?.DUI?.disabled}
          //         options={{
          //           id: "DUI",
          //           name: "DUI",
          //           maxLength: 9,
          //           startWithCero: true,
          //         }}
          //       />

          // </Col>
          <Col sm="4" md="4">
            <Label className="me-1">DUI*</Label>
            <Controller
              id="dui"
              name="dui"
              control={control}
              render={({ field }) => {
                return (
                  <Cleave
                    options={{
                      delimiter: "-",
                      blocks: [8, 1],
                      uppercase: true,
                    }}
                    disabled={input?.DUI?.disabled}
                    placeholder={"Numero DUI"}
                    className={classnames("form-control", {
                      /*'is-invalid':
                      data !== null &&
                      (data.DUI === null ||
                        !data.DUI?.length ||
                        errors.DUI)
                  */
                    })}
                    {...field}
                  />
                );
              }}
            />
            {errors.dui && (
              <FormFeedback className="d-block">
                {errors.dui.message}
              </FormFeedback>
            )}
          </Col>
        )}

        {entitySelected !== "01" && entitySelected !== null && (
          <>
            {/* <Col md="4" sm="12">
          <InputNumber
            label={"NIT*"}
            errors={errors}
            control={control}
            disabled={input?.NIT?.disabled}
            options={{
              id: "NIT",
              name: "NIT",
              maxLength: 14,
              startWithCero: true,
            }}
          />
          </Col> */}
            <Col sm="4" md="4">
              <Label className="me-1">NIT*</Label>
              <Controller
                id="nit"
                name="nit"
                control={control}
                render={({ field }) => {
                  return (
                    <InputMask
                      mask={
                        (entitySelected === "11" || entitySelected === "14") ? null : "9999-999999-999-9"
                      }
                      disabled={input?.NIT?.disabled}
                      placeholder="Número NIT"
                      className={classnames("form-control", {
                        "is-invalid":
                          data !== null &&
                          (data.documentNumber === null ||
                            !data.documentNumber?.length ||
                            errors.documentNumber),
                      })}
                      {...field} // Field props to manage the value and onChange
                    >
                      {() => (
                        <Input
                          {...field}
                          type="text"
                          className="form-control"
                          errors={errors}
                          control={control}
                          disabled={input?.NIT?.disabled}
                        />
                      )}
                    </InputMask>
                  );
                }}
              />
              {errors.nit && (
                <FormFeedback className="d-block">
                  {errors.nit.message}
                </FormFeedback>
              )}
            </Col>
          </>
        )}

        {entitySelected !== "01" &&
          entitySelected !== null &&
          entitySelected !== "11" &&
          entitySelected !== "14" && (
            <Col md="4" sm="12">
              <Label className="me-1">NRC*</Label>
              <Controller
                id="nrc"
                name="nrc"
                control={control}
                rules={{
                  required: "El NRC es requerido",
                  pattern: {
                    value: /^[0-9]{1,8}$/,
                    message: "El NRC debe tener entre 1 y 8 dígitos numéricos",
                  },
                }}
                render={({ field }) => {
                  return (
                    <Cleave
                      options={{
                        numericOnly: true, // Solo permite números
                        delimiter: "-",
                        blocks: [8],
                      }}
                      className={classnames("form-control")}
                      {...field}
                    />
                  );
                }}
              />
              <FormFeedback className="d-block">
                {errors?.nrc?.message}
              </FormFeedback>
            </Col>
          )}
      </Row>

      <Row className="mb-1">
        {/* <Col md="6" sm="12">
          <InputText
            label={"Nombre comercial*"}
            errors={errors}
            options={{
              control,
              id: "tradeName",
              name: "tradeName",
              // disabled: true
            }}
          />
        </Col> */}
        <Col>
          <Label className="me-1">Nombre comercial*</Label>
          <Controller
            name="tradeName"
            control={control}
            render={({ field }) => (
              <>
                <Input
                  {...field}
                  errors={errors}
                  options={{
                    control,
                    id: "tradeName",
                    name: "tradeName",
                    // disabled: true
                  }}
                />
                {errors.tradeName && (
                  <FormFeedback className="d-block">
                    {errors.tradeName.message}
                  </FormFeedback>
                )}
              </>
            )}
          />
        </Col>
        <Col>
          <Label className="me-1">Actividad económica</Label>
          <Controller
            name="economicActivity"
            control={control}
            render={({ field }) => (
              <>
                <Select
                  {...field}
                  options={economicActivityWithCombinedLabel}
                />
                {errors.economicActivity && (
                  <FormFeedback className="d-block">
                    {errors.economicActivity.message}
                  </FormFeedback>
                )}
              </>
            )}
          />
        </Col>
      </Row>

      <Row className="mb-1">
        <Col md="6" sm="12">
          {/* <InputNumber
            label={"Teléfono*"}
            errors={errors}
            control={control}
            options={{
              id: "receiverPhoneNumber",
              name: "receiverPhoneNumber",
              maxLength: 8,
            }}
          /> */}
          <InputInternationalPhone
            label={"Teléfono*"}
            errors={errors}
            control={control}
            options={{
              id: "receiverPhoneNumber",
              name: "receiverPhoneNumber",
            }}
          />
        </Col>
        <Col md="6" sm="12">
          <InputEmail
            label="Correo Electrónico"
            errors={errors}
            control={control}
            options={{
              id: "receiverEmail",
              name: "receiverEmail",
            }}
          />
        </Col>
      </Row>
      {entitySelected !== "11" && (
        <Row className="mb-1">
          <Col md="6" sm="12">
            <Label className="me-1">Departamento</Label>
            <Controller
              name="department"
              control={control}
              render={({ field }) => (
                <>
                  <Select
                    {...field}
                    options={departments}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      setValue("municipality", null); // Resetear municipio seleccionado
                      setValue("district", null); // Resetear distrito seleccionado
                    }}
                  />
                  {errors.department && (
                    <FormFeedback className="d-block">
                      {errors.department.message}
                    </FormFeedback>
                  )}
                </>
              )}
            />
          </Col>
          <Col md="6" sm="12">
            <Label className="me-1">Municipio</Label>
            <Controller
              name="municipality"
              control={control}
              render={({ field }) => (
                <>
                  <Select
                    {...field}
                    options={cities}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      setValue("district", null); // Resetear distrito seleccionado
                    }}
                  />
                  {errors.municipality && (
                    <FormFeedback className="d-block">
                      {errors.municipality.message}
                    </FormFeedback>
                  )}
                </>
              )}
            />
          </Col>
          <Col md="6" sm="12">
            <Label className="me-1">Distrito</Label>
            <Controller
              name="district"
              control={control}
              render={({ field }) => (
                <>
                  <Select
                    {...field}
                    options={districtOptions}
                    isDisabled={!municipality?.value}
                  />
                  {errors.district && (
                    <FormFeedback className="d-block">
                      {errors.district.message}
                    </FormFeedback>
                  )}
                </>
              )}
            />
          </Col>
        </Row>
      )}

      <Row className="mb-1">
        <Col md="6" sm="12">
          <InputText
            label={"Dirección*"}
            errors={errors}
            options={{
              control,
              id: "address",
              name: "address",
              // disabled: true
            }}
          />
        </Col>
        {(entitySelected === "11" || entitySelected === "14") && (
          <Col md="6" sm="12">
            <Label className="me-1">País</Label>
            <Controller
              name="country"
              control={control}
              render={({ field }) => (
                <>
                  <Select {...field} options={countries} />
                  {errors.country && (
                    <FormFeedback className="d-block">
                      {errors.country.message}
                    </FormFeedback>
                  )}
                </>
              )}
            />
          </Col>
        )}
        {entitySelected === "03" && (
          <Col>
            <Label className="me-1">Tipo de contribuyente</Label>
            <Controller
              name="largeConsumer"
              control={control}
              render={({ field }) => (
                <>
                  <Select {...field} options={contributorOptions} />
                  {errors.largeConsumer && (
                    <FormFeedback className="d-block">
                      {errors.largeConsumer.message}
                    </FormFeedback>
                  )}
                </>
              )}
            />
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

export default FormBase;
